export const currentWizardSurvey = state => state.surveyWizard.survey.survey;
export const currentWizardExpenses = state => state.surveyWizard.expenses;
export const currentWizardProjects = state => state.surveyWizard.projects;
export const currentSurveySections = state => state.surveyWizard.survey.surveySections;

export const setSurveyTabs = state => state.surveyWizard.survey.surveyTabs;
